function fn_layout_main() {
    $("body").removeClass("mod--preload");
    setTimeout(function () {
        $("body").addClass("mod--loaded");
    }, 300);

    fn_nl_lib_anchor();
    fn_scrollreveal();

    $(".lib--parallax").find("img:not(.lazyload)").parent().parallax();
    $(document).on('lazybeforeunveil', function (e) {
        if ($(e.target).parent().hasClass("lib--parallax")) {
            $(e.target).parent().parallax();
        }
    });

    nl_lib_dialog.init();
    $("[data-switch]").nl_lib_switch();
    $(".part_ui_btn").nl_lib_ripple();

    var picture = document.createElement('picture'),
        strObj = '' + picture;
    if (strObj.indexOf("HTMLPictureElement") == -1) {
        $.getScript($cdnjs.picturefill);
    }

    $(document).on('submit', 'form.ajax', function (e) {
        e.preventDefault();
        var $frm = $(this);
        $.ajax({
            method: $frm.attr('method'),
            url: $frm.attr('action'),
            data: $frm.serialize(),
            dataType: 'json',
            success: function (payload) {
                if (payload) {
                    if (payload.snippets) {
                        for (var i in payload.snippets) {
                            $("#" + i).replaceWith(payload.snippets[i]);
                        }
                    }
                }
                $frm.parent('.part_dialog').prev('[data-dialog-close]').click();
                $(document).find(".comp_service").closest(".comp_contacts").anchor_anim(500);
                $('.part_datepicker').loadDatepicker();
            }
        });
    });

    if ($("form").length) {
        setTimeout(function () {
            $("form").append('<input name="antispam" value="antispam" type="hidden" />');
        }, 2500);
    }

    $(document).on('change','[data-mobile-select]',function() {
        var uri = $(this).find('option:selected').attr('data-url');
        if(uri) {
            window.location.href = uri;
        }
    });

    $(document).find("[data-lib-tippy]").each(function () {
        var elm = $(this)[0];

        tippy(elm, {
            content: elm.getAttribute('aria-label'),
            interactive: true
        });
    })
}
